import { render, staticRenderFns } from "./licenseWarningBanner.vue?vue&type=template&id=0fe9b102&scoped=true&lang=pug"
import script from "./licenseWarningBanner.vue?vue&type=script&lang=js"
export * from "./licenseWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./licenseWarningBanner.vue?vue&type=style&index=0&id=0fe9b102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe9b102",
  null
  
)

export default component.exports